import { ConnectedTabsWorkspace } from 'components/shared/DragAndDropWorkspace/TabsWorkspace';
import { QuoteWorkspaceProvider } from 'contexts/quote-workspace.context';

import { EmptyWorkspace, PostTradeTabContent } from './Tabs';

export function PrimaryPostTradeWorkspace() {
  return (
    <QuoteWorkspaceProvider value="postTrade">
      <ConnectedTabsWorkspace workspace="postTrade" onAddNewTab={undefined} paddingClassName="ps-1">
        {tab => (tab === null ? <EmptyWorkspace /> : <PostTradeTabContent activeTabId={tab.id} tabType={tab.type} />)}
      </ConnectedTabsWorkspace>
    </QuoteWorkspaceProvider>
  );
}

PrimaryPostTradeWorkspace.displayName = 'PrimaryPostTradeWorkspace';
